import React from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox/styled-components'

import theme from 'theme'
import media from 'media'
import Content from 'components/blog/Content'
import Article from 'components/Article'
import SocialShareButtons from 'components/SocialShareButtons'
import AdditionalResources from 'components/blog/AdditionalResources'

const StyledContent = styled(Content)`
  ol li {
    margin: 18px 0;
  }
`

const Company = styled.div`
  color: ${theme.colors.blacks[40]};
  font-weight: ${theme.fontWeights.bold};
  margin-bottom: -20px;
`

const BodyContainer = styled(Flex).attrs({
  flexDirection: ['column', 'column', 'row'],
})``

const SidePanel = styled(Box)`
  flex: 1;
`

const LeftSidePanel = styled(SidePanel)`
  display: none;

  ${media.giant`
    display: block;
  `}
`

const RightSidePanel = styled(SidePanel)`
  ${media.desktop`
    padding-left: 0px;
    padding-right: 30px;
  `}

  ${media.beyondGiant`
    padding-right: 0px;
  `}
`

const StyledArticle = styled(Article)`
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 20px;

  ${media.desktop`
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 50px;
  `}
`

export default function Body ({
  title,
  summary,
  company,
  path,
  content,
  renderBottomAction,
  additionalResources = [],
}) {
  return (
    <BodyContainer>
      <LeftSidePanel />
      <StyledArticle px={[20]} pb={[20, 20, 50]} p="">
        <StyledContent withUnderscore={false}>
          {company && <Company>{company}</Company>}
          {content}
        </StyledContent>
        <SocialShareButtons
          title={title}
          summary={summary}
          path={path}
          bottomAction={renderBottomAction}
          mt={[40, 40, 36]}
          mb={[20, 20, 80]}
        />
      </StyledArticle>
      <RightSidePanel>
        {additionalResources.length > 0 && (
          <AdditionalResources resources={additionalResources} />
        )}
      </RightSidePanel>
    </BodyContainer>
  )
}
